//物流看板

export default [

    {   //物流看板
        path: "logistics/panel",
        name: "logisticspanel",
        component: () => import(/* webpackChunkName: "logistics" */ "@/views/logisticspanel/index")
    }
]
